import { isBrowser } from '@axo/shared/util/dom';
import { StorageKeys } from '../StorageKeys';

export const clearCrossDomainAuth = () => {
  if (!isBrowser()) return;

  sessionStorage.removeItem(StorageKeys.AppId);
  sessionStorage.removeItem(StorageKeys.Token);
};
